import { ReactNode } from 'react';
import { cx } from '../../../payease.utils';
import './selectable-card.scss';

interface ISelectableCardProps {
  children: ReactNode;
  onClick: () => void;
  active?: boolean;
  className?: string;
}

export const SelectableCard = ({ children, onClick, active, className }: ISelectableCardProps) => (
  <button type="button" className={cx('pe-card', active && 'pe-card--active', className)} onClick={onClick}>
    {children}
  </button>
);
